import React from 'react';
import './TextInputField.css';

const TextInputField = ({ placeholder, value, onChange, name, required }) => {
  return (
    <div className="text-input-field">
      <textarea
        className="text-input-textarea"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        name={name}
        required={required}
        rows={5}
      />
    </div>
  );
};

export default TextInputField;
